import apiClient from '@/services/rest-api-tools/apiClient'

const baseEndpoint = '/command/sensor_setting'

export const create = async (data, region) => {
  const response = await apiClient({
    method: 'POST',
    url: `${baseEndpoint}`,
    data,
    headers: {
      'X-Region': region,
    }
  })
  return response
}
